import { render, staticRenderFns } from "./RememberAccount.vue?vue&type=template&id=73d4aea3&scoped=true&"
import script from "./RememberAccount.vue?vue&type=script&lang=js&"
export * from "./RememberAccount.vue?vue&type=script&lang=js&"
import style0 from "./RememberAccount.vue?vue&type=style&index=0&id=73d4aea3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d4aea3",
  null
  
)

export default component.exports